import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getFailedEntries } from '../../redux/slices/paymentSlice'

const FailedPaymentsBanner = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { allFailedEntries } = useSelector(({ payment }) => payment)

  useEffect(() => {
    dispatch(
      getFailedEntries({
        status: 'failed',
        sort_column: 'booking_date_time',
        sort_order: 'DESC',
        page: 1,
        limit: 1
      })
    )
  }, [])

  const totalFailed = allFailedEntries?.totalRecords || 0

  if (totalFailed === 0) return null

  return (
    <div className="row mb-3">
      <div className="col-12">
        <div
          style={{
            backgroundColor: '#fff2f0',
            border: '1px solid #ffccc7',
            borderRadius: '8px',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: '#ff4d4f',
                display: 'inline-block'
              }}
            />
            <span style={{ color: '#cf1322', fontWeight: 500, fontSize: '14px' }}>
              {totalFailed} failed payment{totalFailed !== 1 ? 's' : ''} require{totalFailed === 1 ? 's' : ''} attention
            </span>
          </div>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => navigate('/payments')}
            style={{ fontSize: '13px' }}
          >
            View Payments
          </button>
        </div>
      </div>
    </div>
  )
}

export default FailedPaymentsBanner
